import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

/**
 * Build jQuery plugins with jQueryBridget package. This resolved an issue
 * when trying to import Masonry class using ES6 module import statements
 */
jQueryBridget('masonry', Masonry, $);


/**
 * @param {jQuery} featuredContainer
 * @param {jQuery} nonFeaturedContainer
 * @param {string} masonryItemSelector
 */
class MNPostGrid {
    constructor(featuredContainer, nonFeaturedContainer, masonryItemSelector, postsPerPage) {

        this.featuredContainer = featuredContainer;
        this.nonFeaturedContainer = nonFeaturedContainer;
        this.masonryItemSelector = masonryItemSelector;
        if ( postsPerPage ) {
            this.postsPerPage = postsPerPage;
        } else {
            postsPerPage = 6;
        }

        this.category = null;

        this.masonryGrid = this.nonFeaturedContainer.masonry({
            itemSelector: this.masonryItemSelector,
            horizontalOrder: true,
            columnWidth: this.masonryItemSelector,
            percentPosition: true,
            transitionDuration: '0.2s',
            gutter: 46
        });

        this.location = window.location.protocol + "//" + window.location.hostname;

        this.store = {};
    }
}


jQuery(document).ready(function($) {

    const $filterUI = $('#filter-ui');
    const $featuredContainer = $('#featured-container');
    const $nonFeaturedContainer = $('#non-featured-container');
    const masonryItemSelector = ".blog-post";

    const mnPostGrid = new MNPostGrid($featuredContainer, $nonFeaturedContainer, masonryItemSelector);

    const $window = $(window);

});
